<template>
  <div class="admin-container">
      <div class="admin-content-container">
          <template>
              <!-- 按钮行 -->
              <div class="bar-row">
                  <div class="left">
                      <el-button
                          @click="toogleMultiSelect('download')"
                          :disabled=" (chooseable && !!multiChoose.mode)|| !hasPermission('download')"
                          icon="el-icon-download"
                          class="wl-green"
                      >
                          {{ $t('BATCH_DOWNLOAD') }}
                      </el-button>
                      
                  </div>
                  <div class="wl-search-bar">
                    <el-button
                        v-if="isKpmgUser"
                        icon="el-icon-plus"
                        @click="toggleAddVisible"
                        class="wl-green mgr10"
                        >{{ $t('COMMON_ADD') }}
                    </el-button>
                      
                      <el-button @click="exportList"  class="wl-green svg-btn" :disabled="!hasPermission('download')">
                          <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                          {{ $t('Export_exchange_Items') }}
                      </el-button>
                      
                  </div>
              </div>
              <!-- 表格 -------------------------------start---------------->
              <div  :class="['table-container-wrapper', chooseable ? 'show-table-bottom-operate' : '']">
                  <el-table
                      height="100%"
                      v-loading="loading"
                      :data="data"
                      @select-all="(e) => handleSelectAll(e, data)"
                      @select="handleSelect"
                      border
                      ref="exchangeTable"
                      class="exchange-table"
                      
                      stripe
                  >
                      <!-- 筛选框 -->
                      <el-table-column v-if="chooseable"  type="selection" width="50">
                          
                      </el-table-column>
                      <!-- 实体名称 -->
                      <el-table-column prop="entityName" width="500" :key="1"  :label="$t('admin.entityName')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                    <el-dropdown style="margin-right: 5px;" trigger="click"  @visible-change="change" v-if="isKpmgUser">
                                    <span class="el-dropdown-link">
                                        <i class="el-icon-edit-outline table-header-edit-cls table-header-blue-icon"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-input
                                            v-model="batchEntityName"
                                            size="mini"
                                            :placeholder="$t('admin.entityName')"
                                            clearable
                                        ></el-input>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                {{ $t('admin.entityName') }}
                                <InputPopover
                                      :value.sync="searchForm.entityName"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></InputPopover>
                                </div>
                            </div>
                        </template>
                          <div class="table-cell" slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.entityName" placement="top-start">
                                <span class="text-with-icon">
                                  {{
                                      scope.row.entityName
                                  }}
                              </span>
                            </el-tooltip>
                            <i class="el-icon-edit table-header-blue-icon" @click="onUpdateEntityNameClick(scope.row,'entityName')" v-if="isKpmgUser"></i>
                        </div>
                      </el-table-column>
                      <!-- 描述 -->
                      <el-table-column prop="description" min-width="300" :key="2" show-overflow-tooltip :label="$t('admin.description')">
                          <div class="table-cell w-full" slot-scope="scope">
                            <el-popover
                                placement="top"
                                width="700"
                                class="text-with-icon"
                                trigger="hover"
                                v-if="scope.row.messageNum > 0">
                                <div>
                                    <div v-for="(v, k) in scope.row.messageList" :key="k">
                                        【
                                        <span>{{ v.sendUserName }} </span>
                                        <span> {{ v.updateDate | formatDateTime }} </span>
                                        】
                                        <span>{{ v.messageContent }}</span>
                                        <br />
                                    </div>
                                </div>
                                <div class="table-td-comment " slot="reference">
                                    <span>{{ scope.row.messageList[0].messageContent }}</span>
                                </div>
                                </el-popover>
                                <i class="el-icon-edit table-header-blue-icon" @click="onUpdateEntityNameClick(scope.row,'description')" v-if="isKpmgUser"></i>
                     
                          </div>
                      </el-table-column>
                      <!-- 签署日期 -->
                      <el-table-column prop="signingDate" width="120" :key="3" show-overflow-tooltip :label="$t('admin.signingDate')">
                          <template slot="header">
                              <div class="header-with-popup">
                                  {{ $t('admin.signingDate') }}
                                  <DatePickerPopover
                                      :value.sync="searchForm.signingDateRange"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></DatePickerPopover>
                              </div>
                          </template>
                          <template slot-scope="scope">
                              <span>{{ scope.row.signingDate | formatDate }}</span>
                          </template>
                      </el-table-column>
                      <!-- 合同性质 -->
                      <el-table-column :key="4" prop="contractType" min-width="200" align="center" show-overflow-tooltip>
                          <template #header>
                              <div class="header-with-popup ">
                                  {{ $t('admin.contractType') }}
                                  <MultiSelectPopver
                                      :hidePopperSearch="hidePopperSearch"
                                      :value.sync="searchForm.contractTypeList"
                                      labelKey="label"
                                      valueKey="value"
                                      :inputFilterKey="['label', 'value']"
                                      :options="categoryOptions"
                                  ></MultiSelectPopver>
                              </div>
                          </template>
                          <template slot-scope="scope">
                            {{ $t(`admin.${scope.row.contractType}`) }}
                          </template>
                      </el-table-column>
                      <!-- 合同 -->
                      <el-table-column :key="5" prop="fileList" width="100" >
                          <template #header>
                              <div class="header-with-popup header-one-center">
                                  {{ $t('admin.contract') }}
                                  <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                      <template #reference>
                                          <div class="th-filter-down">
                                              <i
                                                  :class="[
                                                      'el-icon-arrow-down',
                                                      searchForm.searchContent ? 'el-icon-arrow-down-active' : ''
                                                  ]"
                                              ></i>
                                          </div>
                                      </template>
                                      <template>
                                          <el-input
                                              class="input-with-select"
                                              v-model="searchForm.searchContent"
                                              size="medium"
                                              :placeholder="$t('fileNameKeyword')"
                                              clearable
                                          ></el-input>
                                      </template>
                                  </el-popover>
                              </div>
                          </template>
                          <template slot-scope="scope">
                              <span
                                  class="file-number-hint"
                                  @click="toogleFileDetailVisible(scope.row)"
                                  v-if="scope.row.fileList && scope.row.fileList.length > 0"
                              >
                                  {{ scope.row.fileList.length }}
                              </span>
                          </template>
                      </el-table-column>
                      <!-- 上传合同 -->
                      <el-table-column :key="6"  width="100" :label="$t('COMMON_UPLOAD')" v-if="isKpmgUser" align="center">
                          <template slot-scope="scope">
                              <i
                                  v-if="!isIE"
                                  :class="[
                                      'el-icon-upload',
                                      !hasPermission('upload') ? 'wl-icon-messageBoardNull' : 'wl-icon-messageBoard'
                                  ]"
                                  @click="toogleUploadVisible(scope.row)"
                              ></i>
                              <el-button
                                  v-else
                                  @click="toogleUploadVisible(scope.row)"
                                  size="mini"
                                  :disabled="!hasPermission('upload')"
                                  :class="['el-icon-upload', !hasPermission('upload') ? 'upload-forbid' : 'wl-green']"
                                  >{{ $t('COMMON_UPLOAD') }}</el-button
                              >
                          </template>
                      </el-table-column>
                      
                      <el-table-column :key="9" width="100" v-if="isKpmgUser"  :label="$t('TABLE_HEADER_Action')">
                          <template slot-scope="scope">
                              <div>
                                  <i style="margin-left: 10px" class="el-icon-delete wl-icon-delete" @click="onDelete(scope.row)"></i>
                              </div>
                          </template>
                      </el-table-column>
                  </el-table>
              </div>
              <div class="footer-btn" v-if="chooseable">
                  <el-button class="cancel-btn" @click="cancelChoose" :disabled="!chooseable">
                      {{ $t('btn_cancel') }}
                  </el-button>
                  <el-button
                      @click="tooglebatchDownLoad('download')"
                      :disabled="chooseable && hasSelectedList.length == 0"
                      class="wl-green"
                      v-if="chooseable && multiChoose.mode == 'download'"
                  >
                      {{ $t('COMMON_DOWNLOAD') }}
                  </el-button>
              </div>
              <!------------------表格------------------------end-------------->
              <!-- 分页 -->
              <el-pagination
                  class="wl-pagination"
                  :current-page="pagination.pageNum"
                  :page-size="pagination.pageSize"
                  @current-change="onCurrentPageChange"
                  @size-change="onSizeChange"
                  layout="prev, pager, next, slot, total"
                  :total="pagination.total"
              >
                  <span>
                      <el-select v-model="pagination.pageSize" @change="onSizeChange">
                          <el-option v-for="item in pageOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                      </el-select>
                  </span>
              </el-pagination>
          </template>
      </div>
      <!-- 编辑实体名称 -->
      <UpdateEntityName
          v-if="updateEntityOption.show"
          :show="updateEntityOption.show"
          :onConfirm="confirmUpdateEntityName"
          :value="updateEntityOption.value"
          :type="updateEntityOption.type"
          @close="closeUpdateEntityName"
      ></UpdateEntityName>
      <!-- 新增/编辑的弹框 -->
      <admin-add
          v-if="addVisible"
          :saveLoading="btnLoading"
          :initData="initData"
          :onCancel="toggleAddVisible"
          :categoryOptions="categoryOptions"
          type="contract"
          :onAdd="saveContractItem"
      />
      <!--upload弹窗-->
      <upload v-if="uploadVisible" :initData="rowData" :onCancel="closeUploadVisble" :onAdd="uploadSuccess" source="contract"/>

      <!--        文件详情-->
      <file-detail
          v-if="fileDetailVisbile"
          :id="rowData.id"
          :tableData="rowData.fileList"
          :curUserName="curUserName"
          activeTab="contract"
          :downloadAble="downloadAble"
          :onCancel="toogleFileDetailVisible"
          @on-file-download="downloadFileDetail"
      />

      <!--        下载确认-->
      <file-confirm-modal
          :fileDownloading="fileDownloading"
          ref="FileConfirmModal"
          :groupList="hasSelectedList"
          @ok="downloadMultipleFiles"
          @on-file-download="downloadFileDetail"
          @updateMultipleSelection="updateMultipleSelection"
          :curUserName="curUserName"
          :downloadAble="downloadAble"
          :mode="downloadDialogMode"
      />
  </div>
</template>

<script>
import AdminAdd from './components/AdminAdd'
import upload from './components/upload'
import { mapGetters } from 'vuex'
import fileDetail from './components/file-detail'
import API from '@/api'
import { formatFileSize, isIE, loading, dateFormat } from '@/utils'
import FileConfirmModal from './components/file-confirm-modal'
import { exportFileLogXls } from '@/utils/exportTable'
import { userPermission } from '@/mixins/userPermission.js'
import batchSelectTableMixins from '@/mixins/batchSelectTableMixins.js'
import windowConfig from '@/utils/windowConfig'
import MultiSelectPopver from '@/components/common/MultiSelectPopver.vue'
import { downloadSingleFile, downloadBatchFiles } from '@/utils/useDownload'
import UpdateEntityName from './components/UpdateEntityName'
import DatePickerPopover from '@/components/common/DatePickerPopover.vue'
import InputPopover from '@/components/common/InputPopover.vue'

export default {
  name: 'ContractManagement',
  props:{
    clearFilterActive:Boolean
  },
  components: {
      UpdateEntityName,
      AdminAdd,
      upload,
      fileDetail,
      FileConfirmModal,
      MultiSelectPopver,
      DatePickerPopover,
      InputPopover
  },
  computed: {
      ...mapGetters('common', {
          getUser: 'getUser',
          getSite: 'getSite',
          getEntityIds: 'getEntityIds'
      }),
      isKpmgUser() {
          return this.getUser.userType === '1'
      },
      categoryOptions(){
        return this.contractTypeOpt.map(item=>({
            label:this.$t(`admin.${item.value}`),
            value:item.value
        }))
      }
  },
    mixins: [userPermission, batchSelectTableMixins],
  data() {
      return {
          updateEntityOption:{
              show:false,
              value:'',
              type:''
          },
          pageOptions: [
              { label: '10/' + this.$t('page') + this.$t('page_tip'), value: 10 },
              { label: '50/' + this.$t('page'), value: 50 },
              { label: '100/' + this.$t('page'), value: 100 }
          ],
          searchForm: {
              contractTypeList: [],
              signingDateRange:[],
              entityName:'',
              searchContent:''
          },
          chooseable: false,
          data: [],
          downloadDialogMode: '', // download | export
          pagination: {
              pageNum: 1,
              pageSize: 10,
              total: 0
          },
          loading: false,
          btnLoading: false,
          addVisible: false,
          uploadVisible: false,
          fileDetailVisbile: false,
          rowData: {},
          initData: {}, //编辑/新增传递参数
          fileDownloading: false,
          curUserName: '',
          downloadAble: false,
          
          multiChoose: {
              /* 是否可多选的状态在上层 */
              /* 已选中的数组在上层 */
              mode: '' // download | email
          },
          isIE: false,
          batchEntityName:'',
          contractTypeOpt:[]
      }
  },
  watch: {
    searchForm:{
        deep:true,
        handler(v){
             
            const clearActive = v.contractTypeList.length>0||(v.signingDateRange.length>1&&v.signingDateRange[0].length>0)||v.entityName.length>0||v.searchContent.length>0
            this.$emit("update:clearFilterActive",clearActive)
        }
    }
  },
  async mounted() {
    await this.getContractTypeOpt()
    await this.getTableList()
    await this.queryLimits()
  },
  methods: {
    // 查询当前站点downloadable
    async queryLimits() {
        const { code, data } = await API.clientUser.getSiteConfig({ param: this.getSite.siteId })
        if (code == '1') {
            this.downloadAble = !!data.downloadable
        } else {
            this.$message.error(this.$t(code))
        }
        // 当前文件uploadby
        let userType = this.getUser.userType
        if (userType == '1') {
            this.curUserName = this.getUser.userName
        } else {
            this.curUserName = this.getUser.userAccount
        }
    },
    getContractTypeOpt() {
        API.common.getDict({dictName: 'contract_type'}).then(res => {
          if (res.code !== '1') return;
          this.contractTypeOpt = res.data
        })
      },
    change(val){
        if(!val){
            if(this.batchEntityName){
                this.onBatchUpdate('entityName',this.batchEntityName)
            }
        }
    },
    async onBatchUpdate(column, v) {
            let sendData = {
                ids: this.data.map((v) => v.id)
            }
            sendData[column] = v

            this.loading = true
            const { code } = await API.clientAdmin.batchUpdateContractInfo(sendData)
            if (code != '1') {
                this.$message.error(this.$t(code))
            } else {
                this.getTableList()
            }
            this.loading = false
        },
      onUpdateEntityNameClick(row,type) {
         this.updateEntityOption.show = true;
         this.updateEntityOption.id = row.id;
         this.updateEntityOption.type = type;
         this.updateEntityOption.value = type !== 'description'?row[type]:'';
      },
      closeUpdateEntityName(){
         this.updateEntityOption.show = false;
         this.updateEntityOption.id = null;
         this.updateEntityOption.value = null;
      },
      async confirmUpdateEntityName(v){
          this.loading = true
          const descriptionParams = {
            relationId: this.updateEntityOption.id,
            messageContent: v
        }
        const entityParams = {
            id: this.updateEntityOption.id,
              entityName: v
        }
        const api = this.updateEntityOption.type === 'description'?API.clientAdmin.sendSingleMessageBoard:API.clientAdmin.updateContractEntityName;
        const params = this.updateEntityOption.type === 'description'?descriptionParams:entityParams;
          const { code,data } = await api(params)
          if (code != '1') {
              this.$message.error(this.$t(code))
          } else {
              const findRow = this.data.find(v => v.id == this.updateEntityOption.id)
               
               
              if (findRow) {
                if(this.updateEntityOption.type === 'description'){
                    findRow.messageList.unshift({
                        sendUserName:`${this.getUser.userName}(${this.getUser.profitCenter})`,
                        updateDate:new Date(),
                        messageContent:v
                    })
                    findRow.messageNum++
                }else if(this.updateEntityOption.type === 'entityName'){
                    findRow.entityName = v
                }
                  
              }

              this.closeUpdateEntityName()
          }
          this.loading = false
      },
      toogleClearFilterActive(v) {
          this.clearFilterActive = v
      },
      hidePopperSearch() {
          this.pagination = {
              pageNum: 1,
              pageSize: 10,
              total: 0
          }
          this.getTableList()
      },
      exportList() {
        let params = this.getSearchParams()
          const _loading = loading()
          _loading.download()
          API.clientAdmin
              .exportList(params)
              .then((res) => {
                  if (/application\/json/.test(res.data.type)) {
                      let reader = new FileReader()
                      reader.onload = (e) => {
                          if (e.target.readyState === 2) {
                              let resJson = {}
                              resJson = JSON.parse(e.target.result)
                              this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                          }
                      }
                      reader.readAsText(res.data)
                  }
                  if (/application\/octet-stream/.test(res.data.type)) {
                      let blob = new Blob([res.data])
                      const filename = decodeURI(res.headers['content-disposition'].replace('attachment; filename=', ''))
                      if (isIE()) {
                          navigator.msSaveBlob(blob, filename)
                      } else {
                          let url = window.URL.createObjectURL(blob)
                          let link = document.createElement('a')
                          link.style.display = 'none'
                          link.href = url
                          link.setAttribute('download', filename)
                          document.body.appendChild(link)
                          link.click()
                      }
                  }
              })
              .catch((e) => {})
              .finally(() => {
                  _loading.close()
              })
      },
      toogleMultiSelect(mode) {
          this.multiChoose = {
              mode: mode
          }
          this.chooseable = true
      },
      cancelChoose() {
          this.$refs.exchangeTable.clearSelection()
          this.chooseable = false
      },
      
      
      // 页码
      onCurrentPageChange(val) {
          this.pagination.pageNum = val
          this.getTableList()
      },
      onSizeChange(val) {
          this.pagination.pageNum = 1
          this.pagination.pageSize = val
          this.getTableList()
      },
      async clearAll() {
            this.searchForm = {
                contractTypeList: [],
                signingDateRange:[],
                entityName:'',
                searchContent:''
            }
            await this.getTableList()
      },
      getSearchParams(){
        let params = {
              siteId: this.getSite.siteId,
              ...this.pagination,
              ...this.searchForm,
              startSigningDate: this.searchForm.signingDateRange && this.searchForm.signingDateRange[1] ? dateFormat(new Date(this.searchForm.signingDateRange[0]), 'yyyy-MM-dd') : null,
              endSigningDate: this.searchForm.signingDateRange && this.searchForm.signingDateRange[1] ? dateFormat(new Date(this.searchForm.signingDateRange[1]), 'yyyy-MM-dd') : null,
          }
          return params
      },
      // 获取表格信息
      async getTableList() {
          let params = this.getSearchParams()
          const { code, data } = await API.clientAdmin.queryContractInfo(params)
          if (code === '1') {
              this.data = data.records|| []; 
              this.pagination.total = data.total
              // 回显已选中的
              this.handleEchoData('exchangeTable', this.data)
          } else {
              this.$message.error(this.$t(code))
          }
          this.loading = false
      },
      // 新增
      toggleAddVisible() {
          this.initData = {}
          this.addVisible = !this.addVisible
      },
      // 编辑
      onEdit(row) {
          this.initData = row
          this.addVisible = !this.addVisible
      },
      // 新增---保存
      async saveContractItem(form) {
        form.siteId = this.getSite.siteId
        const { code, data } = await API.clientAdmin.addContractInfo(form)
        try {
            if (code == '1') {
                this.$message.success(this.$t('msg_success'))
            } else {
                this.$message.error(this.$t(code))
            }
        } catch (e) {
            this.$message.error(e)
        }
          this.pagination.pageNum = 1
          await this.getTableList()
          this.addVisible = !this.addVisible
      },
      // 删除
      onDelete(row) {
          this.$confirm(this.$t('msg_delete_sure'), this.$t('COMMON_TIP'), {
              confirmButtonText: this.$t('btn_confirm'),
              cancelButtonText: this.$t('btn_cancel'),
              type: 'warning',
              cancelButtonClass: 'cancel-btn',
              confirmButtonClass: 'wl-green'
          })
              .then(() => {
                  API.clientAdmin.deleteContractInfo({id:row.id}).then((res) => {
                      if (res.code == '1') {
                          this.$message.success(this.$t('msg_success'))
                      } else {
                          this.$message.error(this.$t(code))
                      }
                      this.getTableList()
                  })
              })
              .catch(() => {
                  this.$message({
                      type: 'info',
                      message: this.$t('CANCLE_OPERATION')
                  })
              })
      },
      // upload
      toogleUploadVisible(row) {
            if (!this.hasPermission('upload')) {
              return
          }
          this.rowData = row
          this.uploadVisible = !this.uploadVisible
      },
      closeUploadVisble() {
          this.getTableList()
          this.uploadVisible = !this.uploadVisible
      },
      async uploadSuccess() {
          await this.getTableList()
          this.rowData = this.data.filter((item) => item.id === this.rowData.id)[0]
      },
  
      // 文件详情
      toogleFileDetailVisible(row) {
          this.rowData = row
          this.fileDetailVisbile = !this.fileDetailVisbile
      },
      updateMultipleSelection(row) {
          this.hasSelectedList = row
      },
      // 下载
      downloadFileDetail(v) {
          if (v.length > 0) {
              const list = []
              v.forEach((i, n) => {
                  list.push({
                      id: i.id,
                      fileId: i.fileId,
                      siteEntityId: i.id,
                      siteId: this.getSite.siteId,
                      source: 'contract',
                      fileName: i.name
                  })
              })
              if (list.length === 0) {
                  this.$message.error(this.$t('FILE_LIST_EMPTY_ALERT'))
                  return
              }
              if (list.length === 1) {
                  this.downloadFileListSingle(list[0])
              }

              this.$refs.exchangeTable.clearSelection()
              this.chooseable = false
          }
      },
      async downloadFileListSingle({ siteId, fileId, source, siteEntityId, fileName }) {
          try {
              this.fileDownloading = true
              const downRes = await API.pbc.checkDownloadRight({ siteId, source, siteEntityId })
              if (downRes.code === '1') {
                  const paramsdata = {
                      siteId,
                      id: siteEntityId,
                      tempToken: downRes.data,
                      fileId: fileId,
                      source
                  }
                  downloadSingleFile(paramsdata)
              }
          } catch (e) {
          } finally {
              this.fileDownloading = false
              this.$refs.FileConfirmModal.visible = false
              this.$refs.exchangeTable.clearSelection()
              this.chooseable = false
          }
      },

      // 批量下载页面
      tooglebatchDownLoad(mode) {
          this.downloadDialogMode = mode
          if (this.hasSelectedList.length > 0) {
              let list = []
              this.hasSelectedList.forEach((item) => {
                  if (item.fileList && item.fileList.length > 0) {
                      item.fileList.forEach((f) => {
                          if (
                              !(
                                  this.getUser.userType === '2' &&
                                  !this.downloadAble &&
                                  f.uploadBy &&
                                  f.uploadBy.indexOf('@') !== -1 &&
                                  f.uploadBy.indexOf(this.curUserName) == -1
                              )
                          ) {
                              list.push({
                                  rowId: item.id,
                                  fileName: f.name,
                                  fileId: f.fileId,
                                  bindId: item.id,
                                  siteId: this.getSite.siteId,
                                  source: 'contract'
                              })
                          }
                      })
                  }
              })
              if (list.length === 0) {
                  this.$message.error(this.$t('FILE_LIST_EMPTY_ALERT'))
                  return
              } else if (list.length === 1) {
                  if (mode == 'download') {
                      this.downloadFileListSingle({
                          siteId: this.getSite.siteId,
                          fileId: list[0].fileId,
                          source: 'contract',
                          siteEntityId: list[0].rowId
                      })
                  } else if (mode == 'export') {
                      this.$refs.FileConfirmModal.visible = true
                  }
              } else {
                  this.$refs.FileConfirmModal.visible = true
              }
          }
      },
      // 批量下载
      downloadMultipleFiles(rows) {
          if (this.downloadDialogMode == 'download') {
              if (rows.length === 1) {
                  const { rowId, name, fileId } = rows[0]
                  this.downloadFileListSingle({ siteId: this.getSite.siteId, fileId: fileId, source: 'contract', siteEntityId: rowId })
              } else {
                  let size = 0
                  const list = rows.map((row) => {
                      size += parseInt(row.size || 0)
                      return {
                          siteEntityId: row.rowId,
                          siteId: this.getSite.siteId,
                          fileId: row.fileId,
                          source: 'contract'
                      }
                  })
                  if (size > windowConfig.download.size) {
                      this.$confirm(
                          this.$t('largeSizeFileAlertContent', { size: formatFileSize(windowConfig.download.size) }),
                          this.$t('largeSizeFileAlertTitle'),
                          {
                            distinguishCancelAndClose: true,
                            showConfirmButton:false,
                            cancelButtonText: this.$t('btn_ok'),
                            cancelButtonClass: 'wl-green',
                          }
                      ).then(() => {
                          this.downloadBatchList({ list },size)
                      })
                  } else {
                      this.downloadBatchList({ list },size)
                  }
              }
          } 
      },
      //批量下载
      async downloadBatchList(params,size) {
          try {
            const fileIdList = params.list.map((item) => item.fileId).join(',')
            const reqParams = {
                siteId: this.getSite.siteId,
                fileIdList,
                source:'contract'
            }
            this.$refs.FileConfirmModal.visible = false
            downloadBatchFiles('/file/free/downloadAdminBatchFilesAsZip', reqParams,size)
          } catch (e) {
              this.$message.error(e.message)
          } finally {
              this.fileDownloading = false
              this.$refs.FileConfirmModal.visible = false
              this.$refs.exchangeTable.clearSelection()
              this.chooseable = false
          }
      },
  }
}
</script>

<style scoped>
::v-deep .exchange-table .el-table__body-wrapper {
  height: calc(100% - 44px) !important;
}
.admin-container {
  height: 100%;
  background: #eff1f5;
}
.table-header-blue-icon {
  color: #3879eb;
  font-size: 15px;
  margin-left: 5px;
  cursor: pointer;
      
}
.table-cell {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
}
.table-td-comment {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.admin-content-container {
  background: #fff;
  height: 100%;
}

.clear-filter {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  font-size: 12PX;
}

.clear-filter img {
  margin-right: 5px;
}

.search-row,
.bar-row {
  height: 35PX;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.search-row .el-button,
.bar-row .el-button {
  height: 30PX;
  border-radius: 5px;
}
.left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.search-item {
  margin-right: 20px;
  width: 260px;
}
.search-item .el-date-editor.el-input {
  width: 260px;
}

.wl-search-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-container-wrapper {
  margin-top: 5PX;
  height: calc(100% - 93PX);
  position: relative;
}
.table-container-wrapper.show-table-bottom-operate {
  height: calc(100% - 93PX - 59px);
}
.wl-icon-messageBoard {
  font-size: 18px;
  color: #0292d9;
  cursor: pointer;
}

.wl-icon-messageBoardNull {
  color: #c0c4cc;
  font-size: 18px;
  cursor: pointer;
}

.upload-forbid {
  cursor: not-allowed;
}

.file-number-hint {
  display: block;
  margin-right: 10px;
  width: 100%;
  cursor: pointer;
  user-select: none;
  color: blue;
  text-decoration: underline;
  text-align: center;
}

.wl-icon-no-delete {
  color: #c0c4cc;
  font-size: 18px;
  cursor: pointer;
}

.wl-icon-no-edit {
  color: #c0c4cc;
  font-size: 18px;
  cursor: pointer;
}

.wl-icon-record {
  color: #1aa0a0;
  font-size: 18px;
  cursor: pointer;
}

.input-with-select {
  width: 260px;
  margin-right: 12px;
}

.wl-overflow-tooltip {
  overflow: hidden;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.template-uploader {
  margin-left: 10px;
}

.wl-green {
  height: 32px;
}
.mgr10 {
  margin-right: 10PX;
}
.footer-btn {
  height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
::v-deep .el-pagination .el-select .el-input {
  width: 150px;
}
.header-with-popup {
  display: flex;
  flex-direction: row;
  justify-content: left;
}


.margin-bottom-10 {
  margin-bottom: 10PX;
}
.guide-btn {
  float: right;
  color: #3879eb;
}

</style>

